import React, { useEffect, useRef, useState } from "react";
import { Platform, ScrollView, TouchableOpacity } from "react-native";
import { Box, Divider, Spacer, Chips } from "digiwash-components";
import PageContainer from "../components/PageContainer";
import Header from "../components/AppHeader";
import HeaderWorkspace from "../components/HeaderWorkspace";
import Services from "../containers/Services";
import { useCategories } from "../hooks/useCategories";
import { Helmet } from "react-helmet";

import BasketFloatButton from "../components/BasketFloatButton";
import { useSelector } from "react-redux";
import userSelectors from "../ducks/user/selectors";
import useNavigation from "../hooks/useNavigation";
import useSyncFilterWithParam from "../hooks/useSyncFilterWithParam";
import HeaderContainer from "../containers/HeaderContainer";
import SkeletonCategoriesFilter from "../components/SkeletonCategoriesFilter";
import BannerNotice from "../components/BannerNotice";
import { useHomePageContent } from "../hooks/useHomePageContent";
import { formatNumber } from "digiwash-core";

const webStyles =
  Platform.OS === "web"
    ? {
        scrollViewContainer: {
          width: "100%",
        },
      }
    : {};

function ServicesPage() {
  let nav = useNavigation();

  let { retrieve: homePageContentRetrieve, data: homePageContentData } =
    useHomePageContent();

  let { params, setParam } = useSyncFilterWithParam();
  let id = params?.id;
  let isAuthenticated: boolean = useSelector(userSelectors.getToken);

  let { retrive, categoriesData, loading } = useCategories();
  let [filter, setFilter] = useState<string>(id);
  let containerRef = useRef(null);

  useEffect(() => {
    retrive();
    homePageContentRetrieve();
    if (!id) {
      nav.navigate("Home");
    }
  }, []);

  let category =
    categoriesData &&
    categoriesData?.data?.listCategories.find((item) => {
      return item.id === id;
    });

  return (
    <>
      <Helmet>
        {category ? <title>{category?.name} | دیجی واش</title> : null}
      </Helmet>
      <PageContainer
        insideBeignScrollView={
          <HeaderContainer>
            <Header
              title="انتخاب لباس ها"
              onBack={() => {
                nav.navigate("Home");
              }}
            >
              <>
                <Box style={{ alignItems: "flex-end" }}>
                  {loading ? <SkeletonCategoriesFilter /> : null}
                  <ScrollView
                    onContentSizeChange={() =>
                      Platform.OS === "android"
                        ? containerRef.current?.scrollToEnd({ animated: false })
                        : null
                    }
                    horizontal
                    contentContainerStyle={{
                      flexGrow: 1,
                    }}
                    ref={containerRef}
                    key="Scrolling"
                    style={{
                      ...{
                        flexGrow: 1,
                        direction: "rtl",
                      },
                      ...webStyles.scrollViewContainer,
                    }}
                  >
                    <Box
                      px="m"
                      style={{
                        flexGrow: 1,
                        flexDirection:
                          Platform.OS === "web" ? "row" : "row-reverse",
                      }}
                    >
                      {!loading &&
                        categoriesData?.data?.listCategories.map((item) => {
                          return (
                            <>
                              <TouchableOpacity
                                onPress={() => {
                                  setFilter(item.id);
                                  if (Platform.OS === "web") {
                                    setParam({ name: "id", value: item.id });
                                  }
                                }}
                              >
                                <Chips
                                  title={item.name}
                                  type={
                                    filter === item.id ||
                                    (!filter && item.id === id)
                                      ? "white"
                                      : "primaryTransparent"
                                  }
                                  size="normal"
                                />
                              </TouchableOpacity>
                              <Spacer size="m" />
                            </>
                          );
                        })}
                    </Box>
                  </ScrollView>
                </Box>
                <Divider size="xxl" />
              </>
            </Header>
          </HeaderContainer>
        }
        afterScrollView={isAuthenticated && <BasketFloatButton />}
      >
        <Box>
          <HeaderWorkspace />
          {!!id &&
          id === "cats_6" &&
          !!homePageContentData &&
          homePageContentData?.appInfo[0]?.text ? (
            <>
              <BannerNotice
                text={formatNumber(homePageContentData.appInfo[0].text)}
                bg="primary.dark"
              />
              <Divider size="l" />
            </>
          ) : null}

          {filter ? <Services filter={filter} /> : null}
          <Box style={{ alignItems: "center" }}></Box>
          <Divider size="xxxl" />
          <Divider size="xxxl" />
        </Box>
      </PageContainer>
    </>
  );
}

export default ServicesPage;
